export default {"src":"/_next/static/media/left_window.fd03c02c.svg","height":32,"width":5,"blurWidth":0,"blurHeight":0};